import React from 'react';
import { useRecoilValue } from 'recoil';
import { CardBody } from '../../components/CardBody';
import { CardHeader } from '../../components/CardHeader';
import { allProductsState } from '../../recoil/atoms';
import { ShopNowCardFooter, ShopNowCardSection } from '../HomeLander/HomeLanderMobile';
import { HeroCallout } from '../HeroCallout';
import { WistiaPanel } from '../../components/WistiaPanel';
import { NewsIcons } from '../../product_detail/components/NewsIcons';
import { ShopAllColors } from '../components/ShopAllColors';
import { ProductFeatures } from '../components/ProductFeatures';
import { LanderTopHero } from '../components/LanderTopHero';
import { ProductHandle } from '../../enums/ProductHandle.enum';
import { CardFooter } from '../../components/CardFooter';
import { useLanderControls } from '../LanderContext';
import { ProductReviewQuote } from '../components/ProductReviewQuote';

export const CamiBodysuitLanderMobile: React.FC = () => {
  const allProducts = useRecoilValue(allProductsState);
  const { scrollToProductSection } = useLanderControls();

  const wistiaVideoId = 'txjj1yry1r';
  const padding = { padding: '145.0% 0 0 0' };

  return (
    <>
      <CardBody>
        <LanderTopHero heroImage={'mobile-cami-bodysuit-lander-top-hero-1.jpg'} title={'Cami Bodysuit'} subTitle={`The perfect shaping bodysuit has arrived.`}>
          <HeroCallout
            orderIndex={0}
            label={
              <>
                Adjustable
                <br /> straps
              </>
            }
            titleStyles={{ marginTop: -4, textAlign: 'right' }}
            inlineStyles={{
              mobile: {
                left: `5%`,
                top: `22%`,
                flexDirection: 'row',
                alignItems: 'flex-start',
              },
            }}
          />
          <HeroCallout
            orderIndex={1}
            label={<>Underwire-free lift</>}
            inlineStyles={{
              mobile: {
                left: `22.5%`,
                top: `44%`,
                flexDirection: 'row',
              },
            }}
          />
          <HeroCallout
            orderIndex={2}
            label={
              <>
                Targeted X<br />
                smoothing
              </>
            }
            inlineStyles={{
              mobile: {
                right: `12%`,
                top: `60%`,
                flexDirection: 'row-reverse',
              },
            }}
          />
        </LanderTopHero>
      </CardBody>
      <ShopNowCardFooter onClick={scrollToProductSection} />
      <CardHeader />
      <CardBody>
        <NewsIcons />
        <ProductFeatures
          features={[
            {
              imgName: 'feature-cb-desktop-1.jpg',
              title: 'Underwire-free lift',
              description: 'Ultra supportive, molded bust support provides lift without underwire.',
            },
            {
              imgName: 'feature-cb-desktop-2.jpg',
              title: 'Fully adjustable',
              description: 'Adjust the length of your straps and the fit of the hook and eye gusset.',
            },
            {
              imgName: 'feature-cb-desktop-3.jpg',
              title: 'Targeted smoothing',
              description: 'Targeted X-shaped panel hugs your midsection for extra waist shaping.',
            },
          ]}
        />
        <ProductReviewQuote
          backgroundColor="#DDDADB"
          leftPanelMaxWidth={'50%'}
          rightPanelStyles={{ flex: 1 }}
          rightPanelMaxWidth={'720px'}
          quotes={[
            {
              quoteText: `“The quality of the bodysuit is excellent and most importantly, the petite size is comfortable and fits my body perfectly.”`,
              author: 'Barbara H.',
            },
            {
              quoteText: `“Love my new bodysuit. I am able to wear it all day. Thank you for providing the extra details that most bodysuits don’t have.”`,
              author: 'Naomi W.',
            },
            {
              quoteText: `“As a stylist, nothing has been so seamless under dresses for my clientele. As a consumer I’m beyond impressed with a product that truly holds me in and never rolls up or down.”`,
              author: '-Adriana R.',
            },
          ]}
          imgName="cb-quote-mobile-2.jpg"
        />
        <ShopNowCardSection onClick={scrollToProductSection} />
        <WistiaPanel videoId={wistiaVideoId} responsivePadding={padding} />
        <ShopAllColors product={allProducts[ProductHandle.CamiBodysuit]} />
      </CardBody>
      <CardFooter />
    </>
  );
};

export default CamiBodysuitLanderMobile;
